import styled, { css } from "styled-components";
import { Typography } from "antd";
import { DesignTokens } from "../../../styles/design-tokens";
import { ValueOrFallback } from "../../table/ValueOrFallback";

const { Text } = Typography;
const { fonts } = DesignTokens;

type LabelSize = "xlarge" | "large" | "base" | "small" | "superSmall";

const LabeledItemWrapper = styled.div``;

const Label = styled(Text) <{ size?: LabelSize }>`
  display: block;
  font-family: ${fonts.sansSerifMd};

  ${({ size }) => css`
    ${size && `font-size: ${fonts.sizes[size]}px;`};
  `}
`;

const StyledText = styled(Text) <{ size?: LabelSize }>`
  ${({ size }) => css`
    ${size && `font-size: ${fonts.sizes[size]}px;`};
  `}
`;

export type LabeledItemProps = {
  label: string;
  content?: string | React.ReactNode;
  fallback?: string;
  size?: LabelSize;
};

export const LabeledItem: React.FC<LabeledItemProps> = ({
  label,
  content,
  fallback,
  size,
}) => {
  return (
    <LabeledItemWrapper>
      <Label size={size}>{label}</Label>
      <StyledText size={size}>
        <ValueOrFallback value={content} fallback={fallback ?? ""} />
      </StyledText>
    </LabeledItemWrapper>
  );
};
